import { createContext } from 'react';

import { ExportEventFormContextProps } from './ExportEventFormContext.types';

export const ExportEventFormContext = createContext<ExportEventFormContextProps | undefined>(undefined);
